// extracted by mini-css-extract-plugin
export default {"button-bar":"DisplayImageModal_button-bar__yWHIH","close-button":"DisplayImageModal_close-button__5uRxm","download-button":"DisplayImageModal_download-button__k3LxT"};